export default "__VITE_ASSET__BI2_jSMQ__"